module.exports = __webpack_public_path__ + "media/images/socials/youtube-fe73a924660dc2ad87dc36c38a9b422a.png";